export enum EAdType {
  TextOnlyAd,
  GraphicOnlyAd,
  TextAndGraphicAd,
}

export enum EBackdropType {
  Oceanside,
  MountainView,
  MidwestFields,
  DesertRoad,
  Cityscape,
}

export enum ENationalAdPage {
  cards  = 'cards',
  banner = 'banner',
}

export enum ENationalAdSubpage {
  add  = 'add',
  edit = 'edit',
}
